import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './Register.css';

const Register = () => {
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [code, setCode] = useState('');
  const [countdown, setCountdown] = useState(0);
  const navigate = useNavigate();

  // 手机号校验
  const validPhone = /^1[3-9]\d{9}$/;
  // 密码长度校验
  const validPwd = /^.{6,16}$/;

  const handleSendCode = () => {
    if (!validPhone.test(phone)) {
      alert('请输入正确的11位手机号');
      return;
    }
    setCountdown(60);
    const timer = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) { clearInterval(timer); return 0; }
        return prev - 1;
      });
    }, 1000);
    alert('验证码已发送（演示）');
  };

  const handleRegister = (e) => {
    e.preventDefault();
    if (!validPhone.test(phone)) {
      alert('手机号格式错误');
      return;
    }
    if (!validPwd.test(password)) {
      alert('密码长度需为6-16位');
      return;
    }
    if (!code) {
      alert('请输入验证码');
      return;
    }
    alert('注册成功！');
    navigate('/login');
  };

  return (
    <div className="register-page">
      <div className="register-card">
        <h1 className="register-title">励鲲英语 - 注册</h1>
        <form className="register-form" onSubmit={handleRegister}>
          <div className="form-group">
            <label>手机号</label>
            <input
              type="tel"
              placeholder="请输入手机号"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
            />
          </div>

          <div className="form-group">
            <label>设置密码</label>
            <input
              type="password"
              placeholder="请设置密码（6-16位）"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>

          <div className="form-group code-group">
            <label>短信验证码</label>
            <div className="code-input-wrapper">
              <input
                type="text"
                placeholder="请输入验证码"
                value={code}
                onChange={(e) => setCode(e.target.value)}
              />
              <button
                type="button"
                className="send-code-btn"
                onClick={handleSendCode}
                disabled={countdown > 0}
              >
                {countdown > 0 ? `${countdown}s` : '获取验证码'}
              </button>
            </div>
          </div>

          <button type="submit" className="register-btn">注册</button>
        </form>

        <div className="login-link">
          已有账号？ <Link to="/login">立即登录</Link>
        </div>
      </div>
    </div>
  );
};

export default Register;